/**
 * @generated SignedSource<<2cf01b3b267d345fa92e11d363013a6b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CryptoTransfersTransactionRequiredActions = "BENEFICIARY_DETAILS";
export type CryptoTransfersTransactionStatus = "CANCELED" | "FINISHED" | "NOT_CONFIRMED" | "ON_HOLD" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type CryptoTransfersTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type LegalClassification = "ARTS" | "EMTS" | "NONE" | "OTHER";
export type OwnerType = "LEGAL_ENTITY" | "NATURAL_PERSON" | "NONE";
export type TaxDeclarationStatus = "DECLARED" | "NOT_ELIGIBLE" | "UNDECLARED" | "UNKNOWN";
export type CryptoTransfersTransactionsListInput = {
  assetId?: string | null | undefined;
  coinNetworkId?: string | null | undefined;
  cursor?: string | null | undefined;
  dateEnd?: TimeScalar | null | undefined;
  dateStart?: TimeScalar | null | undefined;
  id?: string | null | undefined;
  size?: number | null | undefined;
  status?: ReadonlyArray<CryptoTransfersTransactionStatus> | null | undefined;
  type?: CryptoTransfersTransactionType | null | undefined;
};
export type CryptoTransfersTransactionsQuery$variables = {
  input: CryptoTransfersTransactionsListInput;
};
export type CryptoTransfersTransactionsQuery$data = {
  readonly cryptoTransfersTransactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly asset: {
          readonly __typename: string;
          readonly id: string;
          readonly legalClassification: LegalClassification | null | undefined;
          readonly logoUrl: string | null | undefined;
          readonly minimumSellAmount: PrecisionFloat | null | undefined;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        };
        readonly assetAmount: PrecisionFloat;
        readonly assetFee: PrecisionFloat;
        readonly createdAt: TimeScalar | null | undefined;
        readonly creditedAt: TimeScalar | null | undefined;
        readonly externalAddress: {
          readonly address: string;
          readonly createdAt: TimeScalar | null | undefined;
          readonly destinationTag: string | null | undefined;
          readonly destinationTagType: string | null | undefined;
          readonly id: string;
          readonly network: {
            readonly coinNetworkId: string;
            readonly id: string;
            readonly name: string | null | undefined;
          };
          readonly ownerIdentifier: string | null | undefined;
          readonly ownerLegalName: string | null | undefined;
          readonly ownerType: OwnerType | null | undefined;
        } | null | undefined;
        readonly fiat: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        };
        readonly fiatAmount: PrecisionFloat;
        readonly fiatFee: PrecisionFloat;
        readonly hash: string | null | undefined;
        readonly id: string;
        readonly network: {
          readonly id: string;
          readonly name: string | null | undefined;
        };
        readonly parentId: string;
        readonly requiredActions: ReadonlyArray<CryptoTransfersTransactionRequiredActions | null | undefined> | null | undefined;
        readonly status: CryptoTransfersTransactionStatus;
        readonly taxDeclarationStatus: TaxDeclarationStatus | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
};
export type CryptoTransfersTransactionsQuery = {
  response: CryptoTransfersTransactionsQuery$data;
  variables: CryptoTransfersTransactionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CryptoTransfersTransactionsConnection",
    "kind": "LinkedField",
    "name": "cryptoTransfersTransactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CryptoTransfersTransactionsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CryptoAddress",
                "kind": "LinkedField",
                "name": "externalAddress",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ownerLegalName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ownerIdentifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ownerType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Network",
                    "kind": "LinkedField",
                    "name": "network",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coinNetworkId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "destinationTag",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "destinationTagType",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logoUrl",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "legalClassification",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "minimumSellAmount",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Fiat",
                "kind": "LinkedField",
                "name": "fiat",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fiatFee",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiredActions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxDeclarationStatus",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creditedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CryptoTransfersTransactionsQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CryptoTransfersTransactionsQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "7c79a36b06cb4246f941f8b4da188e0e",
    "id": null,
    "metadata": {},
    "name": "CryptoTransfersTransactionsQuery",
    "operationKind": "query",
    "text": "query CryptoTransfersTransactionsQuery(\n  $input: CryptoTransfersTransactionsListInput!\n) {\n  cryptoTransfersTransactions(input: $input) {\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        __typename\n        id\n        parentId\n        externalAddress {\n          id\n          address\n          ownerLegalName\n          ownerIdentifier\n          ownerType\n          network {\n            id\n            name\n            coinNetworkId\n          }\n          destinationTag\n          destinationTagType\n          createdAt\n        }\n        asset {\n          id\n          logoUrl\n          name\n          symbol\n          legalClassification\n          minimumSellAmount\n          __typename\n        }\n        assetAmount\n        assetFee\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        fiatFee\n        network {\n          id\n          name\n        }\n        hash\n        status\n        requiredActions\n        taxDeclarationStatus\n        createdAt\n        creditedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "52d3d93ed18e21accddf502f59f4fbc6";

export default node;
